"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RatingField = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _contexts = require("../../contexts");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const RatingField = ({
  name,
  starReviewDescriptions,
  testId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const score = (0, _contexts.useRatingAndReviewWatch)(name);
  const {
    formState: {
      errors
    },
    register,
    setValue
  } = (0, _contexts.useRatingAndReviewForm)();
  const onStarClick = (0, _react.useCallback)(index => () => {
    setValue(name, index + 1, {
      shouldValidate: true
    });
  }, [name, setValue]);
  const onStarKeyDown = (0, _react.useCallback)(index => e => {
    if (e.key === 'Enter') {
      onStarClick(index)();
    }
  }, [onStarClick]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": testId,
    score: score,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Stars, {
      children: Array.from({
        length: 5
      }).map((_, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "aria-label": starReviewDescriptions[index],
        "data-testid": getTestId(_constants.RATING_FIELD_STAR),
        className: _styles.starClasses.star,
        role: "button",
        tabIndex: 0,
        onClick: onStarClick(index),
        onKeyDown: onStarKeyDown(index),
        ...(index === 0 ? register(name) : {}),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Favourite, {
          className: _styles.starClasses.empty
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.FavouriteFilled, {
          className: _styles.starClasses.filled
        })]
      }, index))
    }), starReviewDescriptions.map(description => /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      "data-testid": getTestId(_constants.RATING_FIELD_LABEL),
      className: _styles.starClasses.reviewDescription,
      color:
      // istanbul ignore next @preserve -- Not testable
      errors[name] ? 'error' : 'textPrimary',
      pt: 3,
      children: description
    }, description))]
  });
};
exports.RatingField = RatingField;
